import React from "react";

export default function KPIWidget({ label, value, hint, icon, tone = "primary", delta }) {
  return (
    <article className="kpi-widget h-100">
      <div className="kpi-widget__top">
        <div>
          <div className="kpi-widget__label">{label}</div>
          <div className="kpi-widget__value">{value}</div>
        </div>
        <div className={`kpi-widget__icon kpi-widget__icon--${tone}`}>{icon}</div>
      </div>
      <div className="kpi-widget__bottom">
        <span className="kpi-widget__hint">{hint}</span>
        {delta ? <span className="kpi-widget__delta">{delta}</span> : null}
      </div>
    </article>
  );
}
